import request from '@/utils/request'

// 获取首页轮播图
export function getJobList() {
  return request({
    url: 'app/jobsInformation/getJobList',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/joinus.js